import { render, staticRenderFns } from "./systemuserPermissions.vue?vue&type=template&id=60275d17"
import script from "./systemuserPermissions.vue?vue&type=script&lang=js"
export * from "./systemuserPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports